<template>
    <span 
        class="text-danger"
        v-if="mostrarBtnDesassociarDespesa"
    >
        <i
            class="fa fa-trash fa-lg icon-button"
            title="Desassociar Despesa"
            @click.stop="confirmarDesassociar(pagamentoDespesa.pagamentoDespesaId)"
        ></i>
    </span>
</template>

<script>
import { pagamentoStatus } from './PagamentoStatus'

export default {
    props: {
        pagamento: {
            type: Object,
            default: () => ({})
        },

        pagamentoDespesa: {
            type: Object,
            default: () => ({})
        },

        pagamentosServicos: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarDesassociar(pagamentoDespesaId) {
            this.$swal({
                title: 'Desassociação de Despesa',
                html: `Confirma a desassociação da despesa?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.desassociar(pagamentoDespesaId)
                }
            })
        },

        desassociar(pagamentoDespesaId) {
            this.$store.dispatch('addRequest')
            this.pagamentosServicos
                .desassociarDespesa({
                    pagamentoId: this.$route.params.pagamentoId,
                    pagamentoDespesaId: pagamentoDespesaId
                })
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Registro salvo com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterPagamentoAtualizado')
                        } else {
                            this.$toast.error(
                                'Erro ao desassociar despesa do pagamento.',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    computed: {
        mostrarBtnDesassociarDespesa() {
            return ((this.pagamentoCriado || this.pagamentoReprovado) 
                && this.regrasEdicao
                && this.rotasEdicao)
        },

        pagamentoCriado () {
            return this.pagamento.status === pagamentoStatus.CRIADO
        },

        pagamentoReprovado() {
            return (this.pagamento.status === pagamentoStatus.REPROVADO
                && ((this.pagamentoDespesa.statusIdMov != "F"
                        && this.pagamentoDespesa.statusIdFat != "F" 
                        && this.pagamentoDespesa.statusIdFat != "Q")
                    || this.pagamentoDespesa.tipoMovimentoFinal)
                )
        },

        regrasEdicao() {
            return (this.$temAcesso('DESP-GERAIS-FORN-PAG-03') || 
                    this.$temAcesso('DESP-GERAIS-REQ-PAG-03'))
        },
        
        rotasEdicao() {
            return (this.$route.name == 'DespesasGerais_Requisitantes_Pagamentos_Detalhar' 
                   || this.$route.name == 'DespesasGerais_Fornecedores_Pagamentos_Detalhar')
        },
    }
}
</script>
